import { useRef } from 'react';
import './CustomDropdown.css';

const CustomDropdown = ({ options, selectedValue, onChange, labelRenderer, type = 'default' }) => {
  const detailsRef = useRef(null);

  const selectedLabel =
    options.find((item) => item.value === selectedValue)?.label || 'Выберите';

  const handleOptionClick = (value) => {
    onChange(value);
    if (detailsRef.current) {
      detailsRef.current.removeAttribute('open');
    }
  };

  const dropdownClassName = `custom-dropdown custom-dropdown--${type}`;

  return (
    <div className="custom-dropdown-wrapper">
      <details className={dropdownClassName} ref={detailsRef}>
        <summary className="custom-dropdown__selected">
          {labelRenderer ? labelRenderer(selectedValue) : selectedLabel}
          <span className="custom-dropdown__arrow"></span>
        </summary>
        <ul className="custom-dropdown__options">
          {options.map((item) => (
            <li
              key={item.value}
              className="custom-dropdown__option"
              onClick={() => handleOptionClick(item.value)}
            >
              {item.label}
            </li>
          ))}
        </ul>
      </details>
    </div>
  );
};

export default CustomDropdown;
